module.exports = __webpack_public_path__ + "static/media/S1-39-Rajada-de-Energia-cod75.482d8fb8.png";